import React, { useEffect, useState } from 'react'
import { syncManager, SyncStatus } from '../lib/syncManager'
import { useOnlineStatus } from '../utils/offline'

interface SyncStatusIndicatorProps {
  onClose?: () => void
}

export function SyncStatusIndicator({ onClose }: SyncStatusIndicatorProps) {
  const [syncStatus, setSyncStatus] = useState<SyncStatus>({
    isSyncing: false,
    lastSync: null,
    pendingChanges: 0,
    error: null
  })
  const isOnline = useOnlineStatus()

  useEffect(() => {
    const unsubscribe = syncManager.subscribe(setSyncStatus)
    return unsubscribe
  }, [])

  return (
    <div className="fixed bottom-4 right-4 bg-white shadow-lg rounded-lg p-4 text-sm max-w-xs">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-2">
          <div className={`w-3 h-3 rounded-full ${isOnline ? 'bg-green-500' : 'bg-red-500'}`} />
          <span className="font-medium">{isOnline ? 'Online' : 'Offline'}</span>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 -mr-1"
            aria-label="Close sync status"
          >
            <svg className="w-4 h-4" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        )}
      </div>
      
      {syncStatus.isSyncing && (
        <div className="text-blue-600">Syncing...</div>
      )}
      
      {syncStatus.pendingChanges > 0 && (
        <div className="text-yellow-600">
          {syncStatus.pendingChanges} pending changes
        </div>
      )}
      
      {syncStatus.error && (
        <div className="text-red-600 text-xs mt-1">
          Error: {syncStatus.error}
        </div>
      )}
      
      {syncStatus.lastSync && (
        <div className="text-gray-500 text-xs mt-1">
          Last sync: {new Date(syncStatus.lastSync).toLocaleTimeString()}
        </div>
      )}
    </div>
  )
}